
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "5 outils pour planifier efficacement votre stratégie de contenu",
    description:
      "Découvrez 5 outils indispensables pour planifier votre stratégie de contenu, optimiser vos campagnes et simplifier votre gestion éditoriale. ALEO vous accompagne !",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
